import React from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods"; // assuming you POST the password
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom"; // for redirect

const ConfirmPassword = ({
  passwordshow,
  handlePasswordClose,
  handleDelete,
  type,
}) => {
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationFn: (password) => {
      return postRequest("/profile/delete/confirm", { password }); // adjust endpoint as needed
    },
    onSuccess: (response) => {
      handlePasswordClose();
      handleDelete(type);
    },
    onError: (error) => {
      console.error("Error:", error);
    },
  });

  const validationSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
  });

  const handleFormSubmit = (values) => {
    mutate(values.password);
  };

  return (
    <Modal show={passwordshow} onHide={handlePasswordClose}>
      <Modal.Body>
        <div className="account-created-pop">
          <h3>Confirm Password</h3>
                  <h4>Delete account request</h4>
                  <p>Enter your password to confirm deletion of your account</p>

          <Formik
            initialValues={{ password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({ isSubmitting }) => (
              <FormikForm>
                <Form.Group className="mb-3">
                  <Field
                    name="password"
                    type="password"
                    className="form-control delete "
                    placeholder="Enter password"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger mt-1"
                  />
                </Form.Group>

                <div className="d-flex justify-content-between mt-4 mb-2">
                  <button
                    type="button"
                    className="theme-white-comm-btn"
                    onClick={handlePasswordClose}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="theme-delete-btn">
                    Delete
                  </button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmPassword;
